import { useState } from "react";

const UserAvatar = ({ user, size = 40 }) => {
  const [imgError, setImgError] = useState(false);

  const showImage = Boolean(user?.profileImage && !imgError);

  const formatInitials = (name = "") => {
    const parts = String(name)
      .trim()
      .split(/\s+/)
      .filter(Boolean);

    if (parts.length === 0) return "?";

    const first = parts[0][0]?.toUpperCase() || "?";
    if (parts.length === 1) return `${first}`;

    const last = parts[parts.length - 1][0]?.toUpperCase() || "";
    return `${first}${last}`;
  };

  if (showImage) {
    return (
      <img
        src={user.profileImage}
        alt={user.name}
        width={size}
        height={size}
        className="mr-2 rounded-full object-cover"
        onError={() => setImgError(true)}
      />
    );
  }

  return (
    <div
      className="mr-2 flex shrink-0 items-center justify-center rounded-full text-white"
      style={{
        backgroundColor: user?.userColor || "#ccc",
        width: size,
        height: size,
        color: "white",
        fontWeight: "bold",
        fontSize: `${size * 0.4}px`,
        textTransform: "uppercase",
      }}
    >
      {formatInitials(user?.name)}
    </div>
  );
};

export default UserAvatar;
